// removed by extract-text-webpack-plugin
module.exports = {"result":"U7j4iJbbV _43dVJeXbT _1vKzJd4mF _2i-9bhXIV","name":"Z0Z8VvkZ0 _2OFXNnC9U","address":"_3tVN0P9nl _4kMpFLaRi"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/venue-search/venue-search-results/venue-search-result.css
 ** module id = 2171
 ** module chunks = 0
 **/